import React, { useState, useEffect } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { Row, Col, Card, CardBody, Form, Spinner } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import { postRequest, postRequestForm } from "../../../../components/Common/Utils.js";
import Lightbox from "react-image-lightbox";
import CategoryModal from "components/Modal/CategoryModal.js";
import BannerModal from "components/Modal/BannerModal.js";
import FileUpload from "components/Common/FileUpload.js";
import ProductModal from "components/Modal/ProductModal.js";
import HomeBlockDragModal from "pages/HomeBlockManagement/DragDropModalHomeBlock/HomeBlockDragModal.js";
import ReactTooltip from 'react-tooltip';



export default function UpdateWebBlock() {
  const location = useLocation();
  const state = location.state?.row;

  const [bannerData, setBannerData] = useState({});
  const [previewImage, setPreviewImage] = useState("");
  const [openLightbox, setOpenLightBox] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [CategoryModel, setCategoryModel] = useState(false);
  const [ProductModel, setProductModel] = useState(false);
  const [BannertModel, setBannertModel] = useState(false);
  const [HomeBlockBannerData, setHomeBlockBannerData] = useState([]);
  const [HomeBlockCategoryData, setHomeBlockCategoryData] = useState([]);
  const [HomeBlockProductData, setHomeBlockProductData] = useState([]);
  const [startLoader, setStartLoader] = useState(false);
  const [DragModalShow, setDragModalShow] = useState(false);
  const [DragDrogData, setDragDrogData] = useState([]);
  const [DragDrogTitle, setDragDrogTitle] = useState('');
  let history = useHistory();
  const { id } = useParams();

  useEffect(() => {
    if (!selectedImage) return;
    const reader = new FileReader();
    reader.onload = () => {
      setPreviewImage(reader.result);
    };
    reader.readAsDataURL(selectedImage);
  }, [selectedImage]);

  const showLightBox = (previewImage) => {
    setPreviewImage(previewImage);
    setOpenLightBox(true);
  };

  const HomeBlockDetails = async () => {
    const res = await postRequest("home-block/web/detail-by-id", {
      id: state?._id,
    });

    console.log("home block details ", res?.data?.categories);

    if (res.status) {
      setHomeBlockCategoryData(
        res?.data?.filterBy == "category"
          ? res?.data?.filterByData
          : res?.data?.categories
      );

      setHomeBlockBannerData(res?.data?.banners);
      setHomeBlockProductData(res?.data?.products);
      setBannerData(res?.data);
    } else {
    }
  };

  const UpdateHomeBlock = async (e) => {
    e.preventDefault();

    setLoading(true);

    let payload = {
      ...bannerData,
      homeBlockId: state?._id,
      products: HomeBlockProductData?.map((item) => item?._id),
      categories: HomeBlockCategoryData?.map((item) => item?._id),
      banners: HomeBlockBannerData?.map((item) => item?._id),
      ...(bannerData?.filterBy === "category" && {
        filterByIds: HomeBlockCategoryData?.map((item) => item?._id),
      }),
    };

    const response = await postRequest(`home-block/web/update`, payload);
    setLoading(false);

    if (response.status) {
      toast.success(response.message);
      setTimeout(() => {
        history.goBack();
      }, 1000);
    } else {
      toast.error(response.message);
    }
  };

  const updateValue = (key, value) => {
    setBannerData((prevData) => ({ ...prevData, [key]: value }));
  };

  // category modal start

  const toggleCategoryModel = () => {
    setCategoryModel(!CategoryModel);
  };

  const closeModalCategory = () => {
    setCategoryModel(false);
  };

  const selectCategoryRow = (item) => {
    console.log({ item });

    setHomeBlockCategoryData((prevData) => {
      const itemExists = prevData.some((data) => data._id === item._id);
      if (itemExists) {
        toast.error("This category is already available.");
        return prevData;
      }
      return [
        ...prevData,
        {
          image: item?.image,

          title: item.title || item.name || "Untitled",
          _id: item._id || null,
          show: true,
        },
      ];
    });

    setCategoryModel(false);
  };

  const handleRemoveCategory = (index) => {
    setHomeBlockCategoryData((prevData) => {
      const newData = [...prevData];
      newData.splice(index, 1);
      return newData;
    });
  };

  // category modal end

  // product modal start

  const toggleProductModel = () => {
    setProductModel(!ProductModel);
  };

  const closeModalProduct = () => {
    setProductModel(false);
  };

  const selectProductRow = (item) => {
    setHomeBlockProductData((prevData) => {
      const itemExists = prevData.some((data) => data._id === item._id);
      if (itemExists) {
        toast.error("This Product is already available.");
        return prevData;
      }
      return [
        ...prevData,
        {
          images: [item?.images[0]], // Store the image at the 0 index
          title: item.title || item.name || "Untitled",
          _id: item._id || null,
          show: true,
        },
      ];
    });
  
    setProductModel(false);
  };

  const handleRemoveProduct = (index) => {
    setHomeBlockProductData((prevData) => {
      const newData = [...prevData];
      newData.splice(index, 1);
      return newData;
    });
  };

  // Product modal end

  // banner modal code  start
  const toggleBannertModel = () => {
    setBannertModel(!BannertModel);
  };
  const closeModalBannert = () => {
    setBannertModel(false);
  };

  const selectBannertRow = (item) => {
    console.log({ item });

    setHomeBlockBannerData((prevData) => {
      const itemExists = prevData.some((data) => data._id === item._id);
      if (itemExists) {
        toast.error("This banner is already available.");
        return prevData;
      }
      return [
        ...prevData,
        {
          image: item.image,
          title: item.title || item.name || "Untitled",
          _id: item._id || null,
          show: true,
        },
      ];
    });
    setBannertModel(false);
  };

  const handleRemoveBanner = (index) => {
    setHomeBlockBannerData((prevData) => {
      const newData = [...prevData];
      newData.splice(index, 1);
      return newData;
    });
  };

  // banner modal code  end

  useEffect(() => {
    if (state) {
      setBannerData(state);
    }

    console.log("product data ", { state });
    HomeBlockDetails();
  }, [state]);

  const Handledragdrop = (item, title) => {
    console.log({ item });
    setDragModalShow(true);
    setDragDrogData(item);

    setDragDrogTitle(title)
  };

  const HandledragdropUpdate = (item) => {
    console.log({ item });
    setDragModalShow(false);


    if (DragDrogTitle == "Product List Ordering") {

      setHomeBlockProductData(item)
    } else if (DragDrogTitle == "Category List Ordering") {
      setHomeBlockCategoryData(item)
    } else if (DragDrogTitle == "Banner List Ordering") {
      setHomeBlockProductData(item)
    }

  };

  return (
    <React.Fragment>
      <ToastContainer />
      <Row>
        <Col className="10">
          <div className="page-title-box">
            <h4>Home Block Management</h4>
            <ol className="breadcrumb m-0">
              <li className="breadcrumb-item active">Web Block</li>
              <li className="breadcrumb-item">Update Web Block</li>
            </ol>
          </div>
        </Col>

        <div class="col-md-2 text-end">
          <button
            type="button"
            onClick={() => history.goBack()}
            className="btn btn-primary  btn-lg"
          >
            <i class="fas fa-chevron-left"></i> Back
          </button>
        </div>
      </Row>

      <Row>
        <Col lg={12}>
          <Card>
            {loading ? (
              <CardBody style={{ height: "100px" }}>
                <Spinner
                  color="info"
                  style={{
                    height: "4rem",
                    width: "4rem",
                    position: "absolute",
                    left: "50%",
                  }}
                >
                  Loading...
                </Spinner>
              </CardBody>
            ) : (
              <CardBody>
                <h4 className="card-title">Update Home Block</h4>
                <Form onSubmit={UpdateHomeBlock}>
                  <Row>
                    <Col lg={12} className="ms-lg-auto">
                      <div className="mt-5 mt-lg-4">
                        <div className="row mb-4">
                          <label className="col-sm-3 col-form-label">
                            Title <i
                                  data-tip
                                  data-for="1-title-tooltip"
                                  className="fa fa-info-circle"
                                  style={{ marginLeft: '5px', cursor: 'pointer' }}
                                ></i>

                                <ReactTooltip id="1-title-tooltip" place="right">
                                   Enter the block's title.
                                </ReactTooltip>
                          </label>
                          <div className="col-sm-6">
                            <input
                              type="text"
                              onChange={(e) =>
                                updateValue("title", e.target.value)
                              }
                              value={bannerData?.title || ""}
                              name="title"
                              className="form-control"
                              required
                            />
                          </div>
                        </div>
                        <div className="row mb-4">
                          <label className="col-sm-3 col-form-label">
                            Show Title <i
                                  data-tip
                                  data-for="show-title-tooltip"
                                  className="fa fa-info-circle"
                                  style={{ marginLeft: '5px', cursor: 'pointer' }}
                                ></i>

                                <ReactTooltip id="show-title-tooltip" place="right">
                                 Enable to display the title; disable to hide it.
                                </ReactTooltip>
                          </label>
                          <div className="col-sm-6">
                            <select
                              onChange={(e) =>
                                updateValue("showTitle", e.target.value)
                              }
                              value={bannerData?.showTitle}
                              name="showTitle"
                              className="form-select"
                            >
                              <option selected>Choose any one option</option>

                              <option value="true">Yes</option>
                              <option value="false">No</option>
                            </select>
                          </div>
                        </div>

                        <div className="row mb-4">
                          <label className="col-sm-3 col-form-label">
                            Description
                          </label>
                          <div className="col-sm-6">
                            <input
                              type="text"
                              onChange={(e) =>
                                updateValue("description", e.target.value)
                              }
                              value={bannerData?.description || ""}
                              name="description"
                              className="form-control"
                              required
                            />
                          </div>
                        </div>

                        <div className="row mb-4">
                          <label className="col-sm-3 col-form-label">
                            Type
                          </label>
                          <div className="col-sm-6">
                            <select
                              onChange={(e) =>
                                updateValue("type", e.target.value)
                              }
                              value={bannerData?.type}
                              name="type"
                              className="form-select"
                            >
                              <option selected>Choose any one option</option>

                              <option value="banner">Banners</option>
                              <option value="product">Products</option>
                              <option value="category">Categories</option>
                            </select>
                          </div>
                        </div>

                        {/* <SizeradioModal
                          bannerData={bannerData}
                          updateValue={updateValue}
                        /> */}

                        {bannerData?.type == "banner" && (
                          <>
                            <div className="row mb-4">
                              <label className="col-sm-3 col-form-label">
                                isAutoScroll
                              </label>
                              <div className="col-sm-6">
                                <select
                                  onChange={(e) =>
                                    updateValue("isAutoScroll", e.target.value)
                                  }
                                  value={bannerData?.isAutoScroll}
                                  name="isAutoScroll"
                                  className="form-select"
                                  required
                                >
                                  <option selected>
                                    Choose any one option
                                  </option>
                                  <option value="true">Yes</option>
                                  <option value="false">No</option>
                                </select>
                              </div>
                            </div>

                            <div className="row mb-4">
                              <label className="col-sm-3 col-form-label">
                                Items in a row
                              </label>
                              <div className="col-sm-6">
                                <input
                                  type="number"
                                  onChange={(e) =>
                                    updateValue("itemsInRow", e.target.value)
                                  }
                                  value={bannerData?.itemsInRow || ""}
                                  name="itemsInRow"
                                  className="form-control"
                                  min={0}
                                  required
                                />
                              </div>
                            </div>

                            <div className="row mb-4">
                              <label className="col-sm-3 col-form-label">
                                Ratio (H:W)
                              </label>
                              <div className="col-sm-6">
                                <input
                                  type="text"
                                  onChange={(e) =>
                                    updateValue("ratio", e.target.value)
                                  }
                                  value={bannerData?.ratio || ""}
                                  name="ratio"
                                  className="form-control"
                                  required
                                />
                              </div>
                            </div>

                            <div className="row align-items-start">
                              <label className="col-sm-3 col-form-label">
                                Choose banner
                              </label>
                              {HomeBlockBannerData?.length > 0 && (
                                <>
                                  {HomeBlockBannerData?.map((form, index) => (
                                    <div className="col-lg-4 mb-3">
                                      <div
                                        class="box-custom red-border "
                                        className={
                                          form[index]
                                            ? "box-custom bgcard"
                                            : "box-custom"
                                        }
                                        style={{
                                          border: "1px solid #ccc",

                                          backgroundImage: `url(${form?.image})`,
                                          backgroundRepeat: "no-repeat",
                                          backgroundSize: "cover",
                                        }}
                                      >
                                        <h5
                                          className="title"
                                          style={{ textAlign: "left" }}
                                        >
                                          {form?.title || "Title"}
                                        </h5>

                                        <div className="bottom-footer">
                                          <div className="d-flex align-items-center deal-footer">
                                            <div
                                              className="logo"
                                              style={{ background: "inherit" }}
                                            >
                                              <img
                                                src={form?.image}
                                                alt="logo"
                                                className="rounded-circle"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <div style={{ textAlign: "start" }}>
                                        <button
                                          type="button"
                                          onClick={() =>
                                            handleRemoveBanner(index)
                                          }
                                          className="btn-remove"
                                        >
                                          Remove
                                        </button>
                                      </div>
                                    </div>
                                  ))}
                                </>
                              )}
                              <div className="col-lg-4">
                                <button
                                  type="button"
                                  onClick={toggleBannertModel}
                                  className="modal-custom-button mt-3 mb-3"
                                >
                                  <i class="fas fa-plus"></i>
                                </button>
                                <button
                                  onClick={() =>
                                    Handledragdrop(HomeBlockBannerData, "Banner List Ordering")
                                  }
                                  type="button"
                                  className="btn btn-info"
                                  style={{ marginLeft: "10px" }}
                                >
                                  <i className="fas fa-grip-vertical"></i> Order
                                </button>
                              </div>
                            </div>
                          </>
                        )}

                        {bannerData?.type == "category" && (
                          <>
                            <div className="row align-items-start">
                              <label className="col-sm-3 col-form-label">
                                Choose Category
                              </label>
                              <div className="col-sm-9 col-form-label">
                                <div className="row align-items-start">
                                  {HomeBlockCategoryData?.length > 0 && (
                                    <>
                                      {HomeBlockCategoryData?.map(
                                        (form, index) => (
                                          <div className="col-lg-4 mb-3">
                                            <div
                                              class="box-custom red-border "
                                              className={
                                                form[index]
                                                  ? "box-custom bgcard"
                                                  : "box-custom"
                                              }
                                              style={{
                                                border: "1px solid #ccc",

                                                backgroundImage: `url(${form?.image})`,
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "cover",
                                              }}
                                            >
                                              <h5
                                                className="title"
                                                style={{ textAlign: "left" }}
                                              >
                                                {form?.title || "Title"}
                                              </h5>

                                              <div className="bottom-footer">
                                                <div className="d-flex align-items-center deal-footer">
                                                  <div
                                                    className="logo"
                                                    style={{
                                                      background: "inherit",
                                                    }}
                                                  >
                                                    <img
                                                      src={form?.image}
                                                      alt="logo"
                                                      className="rounded-circle"
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>

                                            <div style={{ textAlign: "start" }}>
                                              <button
                                                type="button"
                                                onClick={() =>
                                                  handleRemoveCategory(index)
                                                }
                                                className="btn-remove"
                                              >
                                                Remove
                                              </button>
                                            </div>
                                          </div>
                                        )
                                      )}
                                    </>
                                  )}

                                  <div className="col-lg-4">
                                    <button
                                      type="button"
                                      onClick={toggleCategoryModel}
                                      className="modal-custom-button mt-3 mb-3"
                                    >
                                      <i class="fas fa-plus"></i>
                                    </button>

                                    <button
                                      onClick={() =>
                                        Handledragdrop(HomeBlockCategoryData, "Category List Ordering")
                                      }
                                      type="button"
                                      className="btn btn-info"
                                      style={{ marginLeft: "10px" }}
                                    >
                                      <i className="fas fa-grip-vertical"></i>{" "}
                                      Order
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        )}

                        {bannerData?.type == "product" && (
                          <>
                            <div className="row mb-4">
                              <label className="col-sm-3 col-form-label">
                                isAuto <i
                                  data-tip
                                  data-for="title-tooltip"
                                  className="fa fa-info-circle"
                                  style={{ marginLeft: '5px', cursor: 'pointer' }}
                                ></i>

                                <ReactTooltip id="title-tooltip" place="right">
                                if yes, the products for chosen category will be auto fetched
                                </ReactTooltip>
                              </label>
                              <div className="col-sm-6">
                                <select
                                  onChange={(e) =>
                                    updateValue("isAuto", e.target.value)
                                  }
                                  value={bannerData?.isAuto}
                                  name="isAuto"
                                  className="form-select"
                                  required
                                >
                                  <option selected>
                                    Choose any one option
                                  </option>
                                  <option value="true">Yes</option>
                                  <option value="false">No</option>
                                </select>
                              </div>
                            </div>

                            <div className="row mb-4">
                              <label className="col-sm-3 col-form-label">
                                Scroll View
                              </label>
                              <div className="col-sm-6">
                                <select
                                  onChange={(e) =>
                                    updateValue("scrollView", e.target.value)
                                  }
                                  value={bannerData?.scrollView}
                                  name="scrollView"
                                  className="form-select"
                                  required
                                >
                                  <option selected>
                                    Choose any one option
                                  </option>
                                  <option value="horizontal">Horizontal</option>
                                  <option value="vertical">Vertical</option>
                                </select>
                              </div>
                            </div>

                            <div className="row mb-4">
                              <label className="col-sm-3 col-form-label">
                                Items in a row
                              </label>
                              <div className="col-sm-6">
                                <input
                                  type="number"
                                  onChange={(e) =>
                                    updateValue("itemsInRow", e.target.value)
                                  }
                                  value={bannerData?.itemsInRow || ""}
                                  name="itemsInRow"
                                  className="form-control"
                                  min={0}
                                  required
                                />
                              </div>
                            </div>

                            <div className="row mb-4">
                              <label className="col-sm-3 col-form-label">
                                Ratio (H:W)
                              </label>
                              <div className="col-sm-6">
                                <input
                                  type="text"
                                  onChange={(e) =>
                                    updateValue("ratio", e.target.value)
                                  }
                                  value={bannerData?.ratio || ""}
                                  name="ratio"
                                  className="form-control"
                                  required
                                />
                              </div>
                            </div>

                            <div className="row mb-4">
                              <label className="col-sm-3 col-form-label">
                                maxItems
                              </label>
                              <div className="col-sm-6">
                                <input
                                  type="number"
                                  onChange={(e) =>
                                    updateValue("maxItems", e.target.value)
                                  }
                                  value={bannerData?.maxItems || ""}
                                  name="maxItems"
                                  className="form-control"
                                  required
                                />
                              </div>
                            </div>

                            {bannerData?.isAuto == "true" && (
                              <div className="row mb-4">
                                <label className="col-sm-3 col-form-label">
                                  Filter By
                                </label>
                                <div className="col-sm-6">
                                  <select
                                    onChange={(e) =>
                                      updateValue("filterBy", e.target.value)
                                    }
                                    value={bannerData?.filterBy}
                                    name="filterBy"
                                    className="form-select"
                                    required
                                  >
                                    <option selected>
                                      Choose any one option
                                    </option>
                                    <option value="none">None</option>
                                    <option value="category">Category</option>
                                    <option value="recently-viewed">
                                      Recently Viewed
                                    </option>
                                    <option value="newly-added">
                                      Newly Added
                                    </option>
                                    <option value="frequently-purchased">
                                      Frequently Purchased
                                    </option>
                                    <option value="hot-deals">Hot Deals</option>
                                    <option value="trending">Trending</option>
                                  </select>
                                </div>
                              </div>
                            )}

                            {bannerData?.filterBy == "category" && (
                              <>
                                <div className="row align-items-start">
                                  <label className="col-sm-3 col-form-label">
                                    Product category
                                  </label>
                                  <div className="col-sm-9 ">
                                    <div className="row align-items-start">
                                      {HomeBlockCategoryData?.length > 0 && (
                                        <>
                                          {HomeBlockCategoryData?.map(
                                            (form, index) => (
                                              <div className="col-lg-4 mb-3">
                                                <div
                                                  class="box-custom red-border "
                                                  className={
                                                    form[index]
                                                      ? "box-custom bgcard"
                                                      : "box-custom"
                                                  }
                                                  style={{
                                                    border: "1px solid #ccc",

                                                    backgroundImage: `url(${form?.image})`,
                                                    backgroundRepeat:
                                                      "no-repeat",
                                                    backgroundSize: "cover",
                                                  }}
                                                >
                                                  <h5
                                                    className="title"
                                                    style={{
                                                      textAlign: "left",
                                                    }}
                                                  >
                                                    {form?.title || "Title"}
                                                  </h5>

                                                  <div className="bottom-footer">
                                                    <div className="d-flex align-items-center deal-footer">
                                                      <div
                                                        className="logo"
                                                        style={{
                                                          background: "inherit",
                                                        }}
                                                      >
                                                        <img
                                                          src={form?.image}
                                                          alt="logo"
                                                          className="rounded-circle"
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div
                                                  style={{ textAlign: "start" }}
                                                >
                                                  <button
                                                    type="button"
                                                    onClick={() =>
                                                      handleRemoveCategory(
                                                        index
                                                      )
                                                    }
                                                    className="btn-remove"
                                                  >
                                                    Remove
                                                  </button>
                                                </div>
                                              </div>
                                            )
                                          )}
                                        </>
                                      )}

                                      <div className="col-lg-4">
                                        <button
                                          type="button"
                                          onClick={toggleCategoryModel}
                                          className="modal-custom-button mt-3 mb-3"
                                        >
                                          <i class="fas fa-plus"></i>
                                        </button>

                                        <button
                                          onClick={() =>
                                            Handledragdrop(
                                              HomeBlockCategoryData, "Category List Ordering"
                                            )
                                          }
                                          type="button"
                                          className="btn btn-info"
                                          style={{ marginLeft: "10px" }}
                                        >
                                          <i className="fas fa-grip-vertical"></i>{" "}
                                          Order
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}

                            <div className="row align-items-start">
                              <label className="col-sm-3 col-form-label">
                                Choose Product
                              </label>
                              <div className="col-sm-9 ">
                                <div className="row align-items-start">
                                  {HomeBlockProductData?.length > 0 && (
                                    <>
                                      {HomeBlockProductData?.map(
                                        (form, index) => (
                                          <div className="col-lg-4 mb-3">
                                            <div
                                              class="box-custom red-border "
                                              className={
                                                form[index]
                                                  ? "box-custom bgcard"
                                                  : "box-custom"
                                              }
                                              style={{
                                                border: "1px solid #ccc",

                                                backgroundImage: `url(${form?.images[0]})`,
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "cover",
                                              }}
                                            >
                                              <h5
                                                className="title"
                                                style={{ textAlign: "left" }}
                                              >
                                                {form?.title || form?.name}
                                              </h5>

                                              <div className="bottom-footer">
                                                <div className="d-flex align-items-center deal-footer">
                                                  <div
                                                    className="logo"
                                                    style={{
                                                      background: "inherit",
                                                    }}
                                                  >
                                                    <img
                                                      src={form?.images[0]}
                                                      alt="logo"
                                                      className="rounded-circle"
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>

                                            <div style={{ textAlign: "start" }}>
                                              <button
                                                type="button"
                                                onClick={() =>
                                                  handleRemoveProduct(index)
                                                }
                                                className="btn-remove"
                                              >
                                                Remove
                                              </button>
                                            </div>
                                          </div>
                                        )
                                      )}
                                    </>
                                  )}

                                  <div className="col-lg-4">
                                    <button
                                      type="button"
                                      onClick={toggleProductModel}
                                      className="modal-custom-button mt-3 mb-3"
                                    >
                                      <i class="fas fa-plus"></i>
                                    </button>

                                    <button
                                      onClick={() =>
                                        Handledragdrop(HomeBlockProductData, "Product List Ordering")
                                      }
                                      type="button"
                                      className="btn btn-info"
                                      style={{ marginLeft: "10px" }}
                                    >
                                      <i className="fas fa-grip-vertical"></i>{" "}
                                      Order
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        )}

                        {/* <div className="row mb-4">
                          <label
                            htmlFor="horizontal-password-input"
                            className="col-sm-3 col-form-label"
                          >
                            Image
                          </label>
                          <div className="col-sm-6">
                            <input
                              type="file"
                              onChange={(e) =>
                                setSelectedImage(e.target.files[0])
                              }
                             
                              name="mediaUrl"
                              className="form-control"
                              id="horizontal-password-input"
                            /> */}
                        {/* <br />
                            {previewImage && (
                              <img
                                src={previewImage}
                                onClick={() => showLightBox(previewImage)}
                                style={{ width: "100px", height: "100px" }}
                              />
                            )} */}

                        <div className="mt-5 mt-lg-4">
                          <div className="row justify-content-end">
                            <div className="col-sm-9">
                              <div>
                                <button
                                  type="submit"
                                  className="btn btn-primary w-md"
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            )}
          </Card>
        </Col>
      </Row>
      {openLightbox && (
        <Lightbox
          mainSrc={previewImage}
          onCloseRequest={() => setOpenLightBox(false)}
        />
      )}
      <CategoryModal
        show={CategoryModel}
        closeModal={closeModalCategory}
        selectRow={selectCategoryRow}
      />

      <ProductModal
        show={ProductModel}
        closeModal={closeModalProduct}
        selectRow={selectProductRow}
      />
      <BannerModal
        show={BannertModel}
        closeModal={closeModalBannert}
        selectRow={selectBannertRow}
      />

      <HomeBlockDragModal
        show={DragModalShow}
        closeModal={() => setDragModalShow(false)}
        data={DragDrogData}
        setData={HandledragdropUpdate}
        title={DragDrogTitle}
      />



  </React.Fragment>

 
)
      }
